var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._m(0),
      _c(
        "a-row",
        [
          _c("a-col", { attrs: { span: "2" } }),
          _c("a-col", { attrs: { span: 20 } }, [
            _c(
              "div",
              { staticClass: "box", staticStyle: { "text-align": "left" } },
              [
                _vm._v(" " + _vm._s(_vm.localValue) + " "),
                _c("div", {
                  staticStyle: {
                    display: "inline-block",
                    height: "25px",
                    width: "1px",
                  },
                }),
              ]
            ),
          ]),
          _c(
            "a-col",
            { attrs: { span: 2 } },
            [
              !_vm.disabled
                ? _c(
                    "a-button",
                    {
                      attrs: { type: "link" },
                      on: {
                        click: function ($event) {
                          return _vm.reChoice(_vm.item)
                        },
                      },
                    },
                    [_vm._v("选择")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm.modalVisable
        ? _c("bad-check-panel-modal", {
            attrs: { visible: _vm.modalVisable, param: _vm.modalParam },
            on: {
              "update:visible": function ($event) {
                _vm.modalVisable = $event
              },
              dialogBack: _vm.onModalClose,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "big-title" }, [
      _c("span", [_vm._v("污染物信息")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }